  <ngx-masonry [options]="masonryOptions" [ordered]="true" [class.notInitialized]="!styleInitialized">
    <div class="grid-sizer default-grid-sizer"></div>
    <div class="gutter-sizer"></div>
    <div
      *ngFor="let item of dataModel(); let i = index"
      class="studio2wx-grid-element">
      @if (styleInitialized) {
        <ng-container *ngTemplateOutlet="cubeTemplateNull(); context: $any({ $implicit: item, index: i })"></ng-container>
      }
    </div>
  </ngx-masonry>
